import { Ionicons } from "@expo/vector-icons";
import { classValidatorResolver } from "@hookform/resolvers/class-validator";
import { Link, router, useFocusEffect } from "expo-router";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ScrollView, View, Text } from "react-native";
import { ActivityIndicator } from "react-native-paper";
import { useDispatch } from "react-redux";

import CounterpartyImage from "@/assets/search.svg";
import Title from "@/components/Title";
import Button from "@/components/button/Button";
import { setForm } from "@/context/actions/actions";
import { useAppSelector } from "@/context/hooks";
import { AccountInformationRequest } from "@/utils/dto/accounts.request";

export default function Counterparty() {
  const [screenFocused, setScreenFocused] = useState(false);

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const globalValues = useAppSelector((state: any) => state);

  const resolver = classValidatorResolver(AccountInformationRequest, {
    validator: { skipMissingProperties: true },
  });

  const { handleSubmit } = useForm<FormData>({
    mode: "onSubmit",
    resolver,
  });

  useFocusEffect(
    React.useCallback(() => {
      setScreenFocused(true);
      dispatch(setForm({ currentTransactionId: "" }));
      return () => {
        setScreenFocused(false);
      };
    }, [globalValues.currentTransactionId, screenFocused])
  );

  const onSubmit = () => {
    router.replace("/home");
  };

  return (
    <ScrollView contentContainerClassName="flex-grow items-center bg-white1 p-4 lg:p-0">
      <Link href="/home/transaction/contacts" asChild>
        <View className="absolute top-0 left-0 m-1.5 z-50">
          <Ionicons name="chevron-back-outline" size={28} color="#BDBDBD" />
        </View>
      </Link>
      <Link href="/home" asChild>
        <View className="absolute top-0 right-0 m-1 z-50">
          <Ionicons name="close-outline" size={32} color="#BDBDBD" />
        </View>
      </Link>
      <View className="my-2">
        <Title text={t("home/counterparty:title")} />
      </View>

      <View className="z-50 flex-col flex-grow w-full items-center justify-center">
        <CounterpartyImage width={280} height={280} />
        <View className="my-3 max-w-136">
          <Text className="text-darkergray text-center text-lg">
            {t("home/counterparty:subtitle")}
          </Text>
        </View>
      </View>
      <Button
        label={t("common:button.backtohome")}
        onClick={handleSubmit(onSubmit)}
      />
    </ScrollView>
  );
}
